import { useState } from 'react';
import { Box, Button, Divider } from '@mui/material';
import { NavBar } from '../appBars/navBar/navBar';
import { MyAddresses } from './myAddresses';
import { NewAddress } from './newAddress';
import { useTranslation } from 'react-i18next';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { AccountSettingsRoute, AddressBookRoute } from '../../routes/allRoutes';

export function AddressBook() {
  const [addNewAddress, setAddNewAddress] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <NavBar barTitle={t('address:addressBook')} />
      <BreadcrumbsBar paths={[{ path: AccountSettingsRoute, isLink: true }, { path: AddressBookRoute }]} />
      <Box
        className={appStyleMode === AppStyle.Mobile && 'address-book'}
        sx={{
          maxWidth: '1000px',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '15px',
        }}
      >
        <MyAddresses />
        <Divider sx={{ m: '15px', borderWidth: '1px' }} />
        {!addNewAddress && (
          <Button
            variant="contained"
            sx={{
              ml: '20px',
              mb: '20px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'secondary.dark',
                boxShadow: 'none',
              },
            }}
            onClick={() => setAddNewAddress(true)}
          >
            {t('address:addNewAddress')}
          </Button>
        )}
        <Box sx={{ px: '20px' }}>
          {addNewAddress && (
            <NewAddress
              onAdded={() => {
                setAddNewAddress(false);
              }}
              onCancel={() => setAddNewAddress(false)}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
